/** @jsx jsx */
import { ElementType } from 'react';
import { jsx } from '@emotion/core';
import styled from '@emotion/styled';
import { useTheme } from '@material-ui/core';
import Skeleton from '@material-ui/lab/Skeleton';

import { ICustomTheme } from 'interfaces';

const SkeletonHeader = styled.div(({ isMobile }: { isMobile: boolean }) => ({
  display: 'flex',
  flexDirection: isMobile ? 'column' : 'row',
  justifyContent: isMobile ? 'start' : 'space-between',
  alignItems: isMobile ? 'center' : 'start',
}));

const SkeletonActionName = styled.div(
  ({ isMobile }: { isMobile: boolean }) => ({
    width: isMobile ? '100%' : '80%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: isMobile ? 'start' : 'space-between',
    alignItems: isMobile ? 'center' : 'start',
  }),
);

export default function Skeletons({
  component: Component = 'div',
  isMobile,
}: {
  component?: ElementType | string;
  isMobile: boolean;
}): JSX.Element {
  const theme: ICustomTheme = useTheme();

  return (
    <Component css={{ padding: theme.spacing(2) }}>
      <SkeletonHeader isMobile={isMobile}>
        <SkeletonActionName isMobile={isMobile}>
          <Skeleton
            variant="text"
            width={isMobile ? '70%' : '50%'}
            height={40}
          />
          {!isMobile && <Skeleton variant="text" width={'60%'} height={40} />}
        </SkeletonActionName>
        <Skeleton variant="text" width={isMobile ? '80%' : '20%'} height={40} />
      </SkeletonHeader>
      <Skeleton variant="text" width={isMobile ? '100%' : '50%'} height={100} />
      <Skeleton
        variant="rect"
        width={'100%'}
        height={120}
        css={{ marginTop: theme.spacing(1) }}
      />
      <Skeleton
        variant="rect"
        width="100%"
        height={120}
        css={{ marginTop: theme.spacing(1) }}
      />
      <Skeleton
        variant="rect"
        width="100%"
        height={120}
        css={{ marginTop: theme.spacing(1) }}
      />
    </Component>
  );
}
